// extracted by mini-css-extract-plugin
module.exports = {"Button":"t_qL p_qL p_qx g_ds g_dH g_dw g_gh","full":"t_rz g_cq g_cB","width100":"t_cq g_cq","design3Pos":"t_rB g_cV"};